class FormQuestionFromTool {
    Id: number;
    Section: any;
    IsRequired: boolean;
    IsSensitive: boolean;
    MaxLength: number;
    Sequence: number;
    LabelText: string;
    Markdown: any;
    MinLength: number;
    FieldType: any;
    ListName: any[];
    SelectedType: string;
    DataName: string;
    OptionGroup: any;
    ServiceIds: any[];
    BrandIds: any[];
    Type: string;

    constructor() {
        this.Id = 0;
        this.Section = {};
        this.IsRequired = false;
        this.IsSensitive = false;
        this.MaxLength = 0;
        this.Sequence = 0;
        this.LabelText = "";
        this.Markdown = {};
        this.MinLength = 0;
        this.FieldType = {};
        this.ListName = [];
        this.SelectedType = "";
        this.DataName = "";
        this.OptionGroup = {};
        this.ServiceIds = [];
        this.BrandIds = [];
        this.Type = "";
    }
}

export default FormQuestionFromTool;